import { createFileRoute, useNavigate, redirect } from '@tanstack/react-router';
import { useState } from 'react';
import { FighterStep } from '../features/rsvp/steps/FighterStep';
import { PageShell } from '../features/rsvp/PageShell';
import { useRsvpFlow } from '../features/rsvp/useRsvpFlow';

export const Route = createFileRoute('/rsvp/fighter')({
  beforeLoad: async () => {
    throw redirect({ to: '/' });
  },
  component: FighterPage,
});

function FighterPage() {
  const navigate = useNavigate();
  const f = useRsvpFlow();
  const [pickedName, setPickedName] = useState<string | null>(null);

  if (!f.draft.child_name) return null;

  return (
    <PageShell globalError={f.globalError}>
      <FighterStep
        characters={f.pickerCharacters}
        selectedName={pickedName}
        onPickFighter={(name) => {
          setPickedName(name);
          navigate({ to: '/rsvp/variant', search: { fighter: name } });
        }}
        onBack={() => navigate({ to: '/rsvp/child' })}
      />
    </PageShell>
  );
}
